import { JSON_getTag, JSON_setTag } from "../repository/globals";

export const statics = {
  values: {}
};

export function staticsSet(keyArray, value) {
  statics.values = JSON_setTag(statics.values, keyArray, value);
}

export function staticsGet(keyArray) {
  return JSON_getTag(statics.values, keyArray)
};

export function staticsReset() {
  statics.values = {};
}
